<script>	
	import Painel from './Painel.svelte';
	
	const opcoes = [
		{
			titulo: "Geral", 
			icone: "listar",
			link: "#/usuario/listagem/geral",
			perfis: "CETREINA"
		},
		{ 
			titulo: "Coordenador(a)", 
			icone: "coordenador",
			link: "#/usuario/listagem/perfil/COORDENADOR",
			perfis: "CETREINA"
		},
		{ 
			titulo: "Discente", 
			icone: "discente",
			link: "#/usuario/listagem/perfil/DISCENTE",
			perfis: "CETREINA"		
		},
		{ 
			titulo: "Avaliador(a)", 
			icone: "avaliador",
			link: "#/usuario/listagem/perfil/AVALIADOR",
			perfis: "CETREINA"
		},
		{ 
			titulo: "Funcionário(a)", 
			icone: "funcionario",
			link: "#/usuario/listagem/perfil/CETREINA",
			perfis: "CETREINA"
		}
	];
</script>

<Painel 
	titulo="Opções de Listagem de Usuários" 
	listaFuncionalidades={opcoes}>
</Painel>